import UiInput from "@/react/story/components/ui/UiInput";
import type { StoryPage } from "@/react/story/types";

type Props = {
    page: StoryPage;
    onSubmit: () => void;
}

export default function PagePublication(props: Props) {
    return (
        <>
            <div>
                <strong className="d-block">Date de début de mise en ligne</strong>
                <UiInput<string>
                    type="date"
                    name="from"
                    defaultValue={props.page.from?.substring(0, 10) ?? ""}
                    onChange={() => props.onSubmit()}
                />
            </div>
            <div>
                <strong className="d-block">Date de fin de mise en ligne</strong>
                <UiInput<string>
                    type="date"
                    name="to"
                    defaultValue={props.page.to?.substring(0, 10) ?? ""}
                    onChange={() => props.onSubmit()}
                />
            </div>
        </>
    );
}
